
(function(){
  var root = document.querySelector('#MainContent');
  if (!root) return;
  var data = {};
  try { data = JSON.parse(document.getElementById('rp2-data').textContent); } catch(e) {}


  var rsiWaiting = false;
  function openRsi(btn){
    var r = document.querySelector('[data-laser-native] ._rsi-buy-now-button');
    if(r){r.click();return;}
    if(rsiWaiting)return;
    rsiWaiting=true;var label=btn.innerHTML,t0=Date.now();btn.textContent='Cargando…';
    (function poll(){var r=document.querySelector('[data-laser-native] ._rsi-buy-now-button');if(r){btn.innerHTML=label;rsiWaiting=false;r.click();return;}if(Date.now()-t0>12000){btn.innerHTML=label;rsiWaiting=false;document.querySelector('.laser-order-status').textContent='El formulario sigue cargando. Intenta de nuevo en unos segundos.';return;}setTimeout(poll,200);})();
  }
  root.querySelectorAll('[data-rp-buy]').forEach(function(b){b.addEventListener('click',function(){openRsi(b);});});

  root.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('active');x.setAttribute('aria-pressed','false'); });
      t.classList.add('active');t.setAttribute('aria-pressed','true');
      var img = t.querySelector('img'), main = root.querySelector('#rp2MainImg img');
      if (img && main) {main.src=img.src;main.alt=img.alt;}
    });
  });

  function play(){
    root.querySelectorAll('video.rp-autoplay').forEach(function(v){
      v.muted = true; v.setAttribute('muted',''); v.playsInline = true;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    });
  }
  play();
  document.addEventListener('DOMContentLoaded', play);
  window.addEventListener('load', play);
  ['touchstart','click','scroll'].forEach(function(e){ window.addEventListener(e, play, {once:true, passive:true}); });

  var els = root.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('on'); }); }
  else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('on'); io.unobserve(en.target); } });
    }, {threshold:.12});
    els.forEach(function(el){ io.observe(el); });
  }

  (function(){
    var chatQA = data.qa || [];
    var greeting = data.greeting || '¡Hola! 👋 Soy el asistente virtual de ECUMAX. Elige una pregunta o escribe la tuya:';
    var fallback = 'Buena pregunta 🙂 Ahora mismo no tengo ese detalle exacto. Toca <b>“Hablar con una persona”</b> para contactar a ECUMAX por correo. Mientras tanto, aquí tienes las dudas más comunes 👇';
    var floatBtn = document.getElementById('rp2ChatBtn'), panel = document.getElementById('rp2ChatPanel'), closeBtn = document.getElementById('rp2ChatClose');
    var body = document.getElementById('rp2ChatBody'), quick = document.getElementById('rp2ChatQuick'), form = document.getElementById('rp2ChatForm'), input = document.getElementById('rp2ChatInput');
    if (!floatBtn || !panel) return;
    var started = false;
    function addMsg(html, who){ var el = document.createElement('div'); el.className = 'chat-msg ' + who; el.innerHTML = html; body.appendChild(el); body.scrollTop = body.scrollHeight; }
    function renderChips(){
      quick.innerHTML = '';
      chatQA.forEach(function(item){
        var chip = document.createElement('button'); chip.type = 'button'; chip.className = 'chat-chip'; chip.textContent = item.q;
        chip.addEventListener('click', function(){ ask(item); }); quick.appendChild(chip);
      });
    }
    function ask(item){ addMsg(item.q, 'user'); setTimeout(function(){ addMsg(item.a, 'bot'); }, 450); }
    function matchInput(text){
      var norm = text.toLowerCase(), best = null, bestScore = 0;
      chatQA.forEach(function(item){ var s = 0; (item.k || []).forEach(function(k){ if (norm.indexOf(k) !== -1) s++; }); if (s > bestScore){ bestScore = s; best = item; } });
      return best;
    }
    function openChat(){ panel.classList.add('open'); if (!started){ started = true; addMsg(greeting, 'bot'); renderChips(); } }
    floatBtn.addEventListener('click', function(){ if (panel.classList.contains('open')) panel.classList.remove('open'); else openChat(); });
    closeBtn.addEventListener('click', function(){ panel.classList.remove('open'); });
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var val = input.value.trim(); if (!val) return;
      addMsg(val.replace(/</g,'&lt;'), 'user'); input.value = '';
      var m = matchInput(val);
      setTimeout(function(){ addMsg(m ? m.a : fallback, 'bot'); }, 450);
    });
  })();
})();

